

var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var CONNECTION_TIMEOUT = 15 * 1000;
var READING_TIMEOUT = 30 * 1000;

var LOW_BATTERY_KEY = "sent_low_metawear_battery";

/**
	* MetaWear Device reading
	*/

module.exports = new Model({
	name: "deviceactivity",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleConnectionFailed: handleConnectionFailed,
	handleProgressUpdated: handleProgressUpdated,
	handleBatteryReading: handleBatteryReading,
	handleFinishReading: handleFinishReading,
	handleResetFinished: handleResetFinished,
	handleDisconnect: handleDisconnect,
	handleFailed: handleFailed,
	handleReset: handleReset,
	readDevice: readDevice,
	cleanState: cleanState,
	clean: clean,
	info: info
});

function init() {
	this._assignedMac = "";
	this._assignedMacs = {};

	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;
	this._isResetting = false;
	this._hasFinishedReset = false;
	this._hasFinishedReading = false;
	this._automatic = false;

	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;
	this._reset = 0;

	this._batteryReadings = [];
	this._resetData = [];
	this._readings = [];

	this._connectionTimeout = null;
	this._readingTimeout = null;
	this._managerId = null;
}

function uninit() {
	this._assignedMacs = null;
	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;
	this._isResetting = false;
	this._hasFinishedReset = false;
	this._hasFinishedReading = false;
	this._automatic = false;

	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;
	this._reset = 0;

	this._batteryReadings = [];
	this._resetData = [];
	this._readings = [];

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._connectionTimeout = null;
	this._readingTimeout = null;
	this._managerId = null;
}

function triggers() {
	return {
		"showinfo": info,
		"workflow": workflow,
		"begin": begin,
		"clean": clean
	};
}

function listeners() {
	return {
		"bluetooth:scanned": handleScanned,
		"bluetooth:connected": handleDeviceConnected,
		"bluetooth:event": handleEvent,
		"bluetooth:disconnected": handleDeviceDisconnected,
		"bluetooth:failed": handleFailed,
		"braceletdata:updated": handle_settings_update,
		"owndevices:updated": handle_devices_update,
		"activemanagegroup:updated": handleManageGroupUpdated
	};
}

function info(data){
	var trigger = "deviceactivity:trigger:begin";
	var message = "myhealthdevice.metawearprepmessage";

	this.emit("bluetooth:trigger:initialize");
	if(data && data.who) this._managerId = data.who;

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for activity", {
		"device type": "MetaWear",
	});
}

function begin(data){
	var isAutomatic = data.automatic;
	this._automatic = isAutomatic;

	if(!isAutomatic)
		this.emit("feedbackmodal:trigger:show", {
			title: "myhealthdevice.read",
			items: {
				connect: {
					type: "load",
					progress: 0,
					message: "myhealthdevice.connecting"
				},
				reading: {
					type: "progress",
					progress: 0,
					message: "myhealthdevice.reading",
					cancelTrigger: "myhealthdevice:trigger:clean"
				}
			}
		});

	this.emit("usermetrics:trigger:track", "begin read from device for activity", {
		"device type": "MetaWear",
	});

	this.readDevice();
}

function readDevice(){
	this._isScanning = true;

	this._connectionTimeout = setTimeout(handleConnectionFailed.bind(this), CONNECTION_TIMEOUT);

	this.emit("bluetooth:trigger:scan");
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.scanning"
		}
	});
}

function handleScanned(scanned){
	var name = "MetaWear";
	var isScanning = this._isScanning;
	var assignedMacs = this._assignedMacs;
	var macKeys = Object.keys(assignedMacs);
	var isMacs = macKeys.length;
	var macExists = macKeys.indexOf(scanned.id) !== -1;

	if(!isScanning) return;
	if(!(scanned && scanned.name && scanned.name.indexOf(name) !== -1)) return;
	if(isMacs && !macExists) return;

	var found = scanned.id;
	this._isScanning = false;
	this._isConnecting = true;
	this._deviceMac = found;

	this.emit("bluetooth:trigger:scan:stop");
	this.emit("bluetooth:trigger:connect", {
		mac: found,
		model: "metawear"
	});
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.connecting"
		}
	});
}

function handleDeviceConnected(){
	var isConnecting = this._isConnecting;
	if(!isConnecting) return;

	this._isConnecting = false;
	this._hasConnected = true;
	this._isListening = true;

	clearTimeout(this._connectionTimeout);
	this._readingTimeout = setTimeout(handleFailed.bind(this), READING_TIMEOUT);

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.connected"
		}
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_INITIALIZE",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:read", {
		service: "DEVICE_BATTERY_SERVICE",
		characteristic: "DEVICE_BATTERY_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:listen", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_READ_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_CONFIGURE",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_START",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_STEP_READ",
		device: this._deviceMac
	});
}

function handleEvent(event){
	var isListening = this._isListening;
	var isResetting = this._isResetting;
	var readings = this._readings;

	var char = event.characteristic;
	if(!isListening) return;

	var data = event.data;

	this._isRead = true;
	clearTimeout(this._readingTimeout);

	if(char === "METAWEAR_READ_CHARACTERISTIC"){
		if(isResetting){
			this._resetData = [].concat(data);
			this.handleResetFinished();
		} else {
			this._readings = readings.concat(data);
			this.handleFinishReading();
		}
		this.handleProgressUpdated();
	} else if(char === "DEVICE_BATTERY_CHARACTERISTIC"){
		this._batteryReadings = [].concat(data);
		this.handleBatteryReading();
	}
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 2)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / 2,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isWorkflow = this._isWorkflow;
	var isRead = this._isRead;
	var manageGroup = this._manageGroup;

	if(!isRead) return;

	var reading = formatReading(readings);

	this._hasFinishedReading = true;
	this._isResetting = true;

	var processReading = null;
	if(isWorkflow){
		processReading = handleWorkflow.bind(this);
	} else if(this._managerId) {
		reading.managerId = this._managerId;
		if(manageGroup)
			reading.group = manageGroup;
		processReading = this.api.manage.steps.add;
	}else{
		processReading = this.api.device.activity.steps.add;
	}

	return processReading(reading)
		.then(handleReset.bind(this))
		.catch(function(e){
			console.log("Error submitting steps: ", e);
		});
}


function handleWorkflow(reading){
	return new Promise(function(resolve){
		var legible = legibleReading(reading);
		this.dispatch("reading", {
			legible: legible,
			value: reading
		});
		resolve();
	}.bind(this));
}

function handleReset(){
	this._reset++;

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_STEP_RESET",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_STOP",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_LED_CLEAR",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_LED_CONFIGURE",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_LED_PLAY",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_STEP_READ",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_START",
		device: this._deviceMac
	});
}

function handleResetFinished(){
	var reset = this._reset;
	var readings = this._resetData;
	var reading = formatReading(readings);

	if(!readings) return;

	var value = reading.value;
	if(value === 0 || reset >= 2){
		this._hasFinishedReset = true;
		setTimeout(handleDisconnect.bind(this), 5000);
	} else {
		this.handleReset();
	}
}

function handleDisconnect(){
	var isListening = this._isListening;
	var hasConnected = this._hasConnected;
	var deviceMac = this._deviceMac;

	this._reset = 0;

	if(isListening){
		this.emit("bluetooth:trigger:listen:stop", {
			service: "METAWEAR_SERVICE",
			characteristic: "METAWEAR_READ_CHARACTERISTIC",
			device: deviceMac
		});
		this._isListening = false;
	}

	if(hasConnected){
		this._isDisconnecting = true;
		this._hasConnected = false;
		this.emit("bluetooth:trigger:disconnect", {
			mac: deviceMac
		});
	}
}

function handleDeviceDisconnected(){
	var hasFinishedReset = this._hasFinishedReset;
	if(hasFinishedReset)
		this.clean();
	else
		this.handleFailed();
}

function handleFailed(){
	var isScanning = this._isScanning;
	var isConnecting = this._isConnecting;
	var hasConnected = this._hasConnected;
	var isAutomatic = this._automatic;
	var retryConnect = this._retryConnect;
	var isWorkflow = this._isWorkflow;

	if((isScanning || isConnecting || hasConnected) && retryConnect <= 2){
		this.handleConnectionFailed();
		return;
	}

	if(!(isScanning || isConnecting || hasConnected)) return;
	this._hasFailed = true;

	this.clean();
	this._isWorkflow = isWorkflow;

	if(!isAutomatic)
		this.emit("feedbackmodal:trigger:show", {
			title: "myhealthdevice.failedtitle",
			items: {
				continue: {
					message: "myhealthdevice.failed",
					type: "confirmcancel",
					trigger: "myhealthdevice:trigger:begin",
					cancelTrigger: "myhealthdevice:trigger:clean"
				}
			}
		});

	this.handleDisconnect();
}

function handleConnectionFailed(){
	var retried = ++this._retryConnect;

	clearTimeout(this._connectionTimeout);

	if(retried <= 2)
		this.readDevice();
	else
		this.handleFailed();
}

function clean(){
	this.emit("feedbackmodal:trigger:hide");
	if(this._isScanning)
		this.emit("bluetooth:trigger:scan:stop");
	this.cleanState();
}

function cleanState(){
	if(this._hasConnected || this._isListening)
		this.handleDisconnect();

	this._isResetting = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;
	this._hasFinishedReset = false;
	this._hasFinishedReading = false;
	this._automatic = false;

	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;
	this._reset = 0;

	this._batteryReadings = [];
	this.resetData = [];
	this._readings = [];

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._connectionTimeout = null;
	this._readingTimeout = null;
}


function workflow() {
	this._isWorkflow = true;
	this.info();
}

function handle_settings_update(data) {
	var mac = data.mac || "";
	var model = data.model || "";
	var macs = this._assignedMacs;
	var assignedMac = this._assignedMac;

	if(assignedMac !== mac)
		delete macs[assignedMac];

	if ((model && model.indexOf("meta") === -1) || !mac){
		this._assignedMac = "";
		return;
	}

	macs[mac] = {
		mac: mac,
		old: true,
		automatic: !!(model === "meta")
	};

	this._assignedMacs = macs;
	this.emit("bluetooth:trigger:initialize");
}

function handleBatteryReading(){
	var assignedMacs = this._assignedMacs;
	var deviceMac = this._deviceMac;

	var readings = this._batteryReadings;
	var reading = formatBatteryReading(readings);

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.batterylevel",
			messageArgs: {
				battery: reading
			}
		}
	});

	if(!Object.keys(assignedMacs).length) return;

	var device = assignedMacs[deviceMac];
	if(!device) return;

	if(device.old){
		this.api.org.devices.battery(reading);
		checkLowBatterySent().then(function(isSet){
			if(!isSet && reading <= 30){
				this.api.banner.warning.device.manager.battery(reading).then(function(){
					return setLowBatterySent(true);
				}).catch(function(err){
					console.log(err);
				});
			} else if(isSet && reading >= 60){
				this.api.banner.warning.device.manager.batterychanged().then(function(){
					return setLowBatterySent(false);
				}).catch(function(err){
					console.log(err);
				});
			}
		}.bind(this));
	} else {
		this.api.devices.battery(device._id, reading);
	}
}

function formatReading(readings) {
	var latestReading = readings[readings.length - 1];
	var steps = latestReading[2] + (latestReading[3] * 0x0100);
	return {
		timestamp: new Date(),
		value: steps
	};
}

function legibleReading(readings) {
	return readings.value;
}

function formatBatteryReading(readings){
	var latestReading = readings[readings.length - 1];
	return latestReading[0];
}

function checkLowBatterySent(){
	return AsyncStorage.getItem(LOW_BATTERY_KEY).then(function(isSet){
		return isSet === "true";
	});
}

function setLowBatterySent(set){
	return AsyncStorage.setItem(LOW_BATTERY_KEY, "" + set);
}

function handle_devices_update(data){
	var list = data.list;
	var assignedMac = this._assignedMac;
	var macs = this._assignedMacs;
	var initial = {};

	// eslint-disable-next-line no-prototype-builtins
	if(assignedMac && macs.hasOwnProperty(assignedMac))
		initial[assignedMac] = macs[assignedMac];

	var newMacs = list.reduce(function(acc, device){
		if(device.device_type === "activity")
			acc[device.mac] = device;
		return acc;
	}, initial);

	this._assignedMacs = newMacs;
}

function handleManageGroupUpdated(group){
	this._manageGroup = group;
}